import { useTranslation } from 'react-i18next';
import type { AdContacts } from '@barter/shared';

interface ContactButtonProps {
  contacts: AdContacts;
  adId?: string;
  /** Ссылка на исходник (скрап OLX) — прямых контактов у таких объявлений нет. */
  sourceUrl?: string;
}

// Уведомление продавцу о просмотре контактов убрано вместе с бот-рассылками.

/** «+380961234567» / «096 324 0061» → ссылки мессенджеров по номеру телефона. */
function phoneMessengers(phone?: string): { wa: string; viber: string } | null {
  if (!phone) return null;
  const digits = phone.replace(/\D/g, '');
  const intl =
    digits.length === 12 && digits.startsWith('380')
      ? digits
      : digits.length === 10 && digits.startsWith('0')
        ? `38${digits}`
        : null;
  if (!intl) return null;
  return { wa: `https://wa.me/${intl}`, viber: `viber://chat?number=%2B${intl}` };
}

export function ContactButton({ contacts, sourceUrl }: ContactButtonProps) {
  const { t } = useTranslation();
  // Явный whatsapp-контакт важнее; иначе WhatsApp/Viber выводятся из телефона.
  const fromPhone = contacts.whatsapp ? null : phoneMessengers(contacts.phone);
  const waHref = contacts.whatsapp
    ? `https://wa.me/${contacts.whatsapp.replace(/[^0-9]/g, '')}`
    : fromPhone?.wa;

  return (
    <div className="contact-buttons">
      {contacts.telegram && (
        <a
          className="contact-btn contact-btn--telegram"
          href={`https://t.me/${contacts.telegram.replace('@', '')}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('adDetails.telegram')}
        </a>
      )}
      {contacts.phone && (
        <a className="contact-btn contact-btn--phone" href={`tel:${contacts.phone}`}>
          {t('adDetails.call')}
        </a>
      )}
      {waHref && (
        <a
          className="contact-btn contact-btn--whatsapp"
          href={waHref}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('adDetails.whatsapp')}
        </a>
      )}
      {fromPhone?.viber && (
        <a className="contact-btn contact-btn--viber" href={fromPhone.viber}>
          {t('adDetails.viber')}
        </a>
      )}
      {sourceUrl && (
        <a
          className="contact-btn contact-btn--olx"
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('adDetails.sourceLink')}
        </a>
      )}
    </div>
  );
}
